import { NotFound as InflearnNotFound } from '@inflearn/errors';

import { NEXT_PUBLIC_CDN_URL, NEXT_PUBLIC_SITE_URL } from '../../appConfig';

export default function NotFound() {
  const referUrl =
    typeof document !== 'undefined' && !!document.referrer
      ? document.referrer
      : NEXT_PUBLIC_SITE_URL || '';

  const handleGoBack = () => {
    window.location.replace(referUrl);
  };

  return (
    <div css={{ position: 'relative', height: '100vh' }}>
      <InflearnNotFound
        onClickGoBack={handleGoBack}
        cdnLink={NEXT_PUBLIC_CDN_URL ?? 'https://cdn.inflearn.com'}
      />
    </div>
  );
}
